<template>
  <div>
    <div class="chatvisa-popover" v-show="showChatPopover">
      <div class="chatvisa-popover-header">
        <div class="chatvisa-popover-header-left">
          <div class="icon-logo">
            <img src="https://o.666visa.cn/static/ssqpeer/chatvisa/chatvisa-logo.png" alt="">
          </div>
          <div class="chatvisa-theme">
            <img class="chatvisa-title" src="https://o.666visa.cn/static/ssqpeer/chatvisa/chatvisa-title.png" alt="" />
            <div class="chatvisa-tips">随时随地为你解答签证疑问</div>
          </div>
        </div>
        <img class="icon-close"  @click="handleKnow()" src="https://o.666visa.cn/static/ssqpeer/chatvisa/chatvisa-close.png" alt="" />
      </div>
      <div class="chatvisa-content">
        <img src="https://o.666visa.cn/static/ssqpeer/chatvisa/chatvisa-gif1.gif" alt="">
      </div>
      <div class="chatvisa-popover-footer">
        <div class="chatvisa-button button-know" @click="handleKnow()">知道了</div>
        <div class="chatvisa-button button-experience" @click="handleTry()">立即体验</div>
      </div>
    </div>
    <div class="chatvisa-entrance-float" @click="gotoChatvisa"></div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import sensorsdata from 'sa-sdk-javascript';
import User from '@/libs/user';
import BasePopoverForNewFunction from '@/components/common/popover/base-popover-for-new-function.vue';

// 给国家页和商品页用的chatvisa入口
export default {
  components: {
    BasePopoverForNewFunction,
  },
  props: {
    visa_country_id: Number,
    sensorData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      storageKey: 'showChatFrame',
      showChatPopover: true,
      sensorsdataInfo: {
        source: '',
      },
    };
  },
  computed: {},
  created() {
    const hasShowed = localStorage.getItem(this.storageKey);
    if (!hasShowed) {
      this.showChatPopover = true;
    } else {
      this.showChatPopover = false;
    }
  },
  mounted() {
    this.initAdjustFloatingButton();
  },

  methods: {
    ...mapMutations('chatVisa', ['handleShowChatVisaFrame']),
    handleKnow() {
      localStorage.setItem(this.storageKey, true);
      this.showChatPopover = false;
    },

    async openChatFrame() {
      this.handleKnow();
      this.handleShowChatVisaFrame({
        visa_country_id: this.visa_country_id,
        sensorData: this.sensorData,
      });
      sensorsdata.track('qw_view', this.sensorData);
    },
    // 根据ID查商品
    gotoChatvisa() {
      this.openChatFrame();
    },
    handleTry() {
      if (User.isLogin) {
        this.openChatFrame();
      } else {
        this.openChatFrame();
      }
    },
    adjustFloatingButton() {
      const button = document.querySelector('.chatvisa-popover');
      if (!button) return;
      const screenWidth = window.innerWidth;

      if (screenWidth < 1700) { // 设置小屏幕的阈值
        button.style.marginRight = `${1700 - screenWidth}px`; 
      } else {
        button.style.marginRight = '0px'; 
      }
    },
    initAdjustFloatingButton() {
      this.adjustFloatingButton(); // 页面加载时立即执行
      window.addEventListener('resize', this.adjustFloatingButton); // 监听窗口调整事件
    },
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.adjustFloatingButton);
  },
};
</script>

<style lang="less" scoped>
.chatvisa-popover {
  width: 368px;
  height: 337px;
  background: #ffffff;
  box-shadow: 0px 3px 16px 0px rgba(30, 43, 61, 0.12);
  margin-bottom: 10px;
  position: relative;
  .chatvisa-popover-header {
    width: 100%;
    height: 61px;
    background: linear-gradient(270deg, #ffffff 0%, #f3f0ff 30%, #f0f6ff 100%);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.06);
    border-radius: 4px 4px 0px 0px;
    padding: 0 16px;
    display: flex;
    justify-content: space-between;
    .chatvisa-popover-header-left {
      height: 61px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 8px;
      .icon-logo {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: linear-gradient(224deg, #8765ff 0%, #6facff 100%);
        >img{
          display: block;
          width: 23px;
          height: 23px;
        }
      }
      .chatvisa-theme {
        display: flex;
        flex-direction: column;
        gap: 6px;
        .chatvisa-title {
          width: 186px;
          height: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 16px;
          color: #8765ff;
          line-height: 16px;
        }
        .chatvisa-tips{
          font-weight: 400;
          font-size: 12px;
          color: #5F666E;
          line-height: 12px;
          }
      }
    }
    .icon-close {
      display: block;
      width: 16px;
      height: 16px;
      margin-top: 12px;
      cursor: pointer;
    }
  }
  .chatvisa-content{
    height: 200px;
    background: #F6F8FE;
    border-radius: 4px;
    margin: 16px;
  }
  .chatvisa-popover-footer{
    position: absolute;
    width: 100%;
    left: 0;
    right: 0;
    bottom: 17px;
    // height: 54px;
    background: #fff;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    .chatvisa-button{
      width: 73px;
      height: 28px;
      line-height: 28px;
      font-size: 12px;
      text-align: center;
      border-radius: 2px;
      cursor: pointer;
    }
    .button-experience{
      color: #fff;
      background: linear-gradient( 224deg, #8765FF 0%, #6FACFF 100%);
    }
    .button-know{
      color: #333;
      border: 1px solid #ddd;
    }
  }
}
.chatvisa-entrance-float {
  width: 106px;
  height: 94px;
  background: url(https://o.666visa.cn/static/ssqpeer/chatvisa/chatvisa-entrance-bg.png)
    no-repeat center / 100% 100%;
  border-radius: 3px;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/chat-visa/component-external/chatvisa-entrance-float.vue